{
  "version": 1,
  "asset_id": "b7706ad8-a61c-4de4-bc56-4272c1f56555",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b7706ad8-a61c-4de4-bc56-4272c1f56555/hiatal-normal-v3-1254.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b7706ad8-a61c-4de4-bc56-4272c1f56555/hiatal-normal-v3-1254.jpg",
  "original_filename": "hiatal-normal-v3-1254.jpg",
  "size": 245755,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:12:04Z"
}
